module.exports = __webpack_public_path__ + "static/media/close.537a5371.svg";